import {
  CREATE_NEW_AD,
  DELETE_AD,
  DELETE_AD_ERROR,
  DELETE_AD_SUCCESS,
  DUPLICATE_AD,
  DUPLICATE_AD_ERROR,
  DUPLICATE_AD_SUCCESS,
  GET_ADS,
  GET_ADS_ERROR,
  GET_ADS_STATS,
  GET_ADS_STATS_ERROR,
  GET_ADS_STATS_SUCCESS,
  GET_ADS_SUCCESS,
  GET_AD_BY_ID,
  GET_AD_BY_ID_ERROR,
  GET_AD_BY_ID_SUCCESS,
  GET_QF_CREATIVES_STATS,
  GET_QF_CREATIVES_STATS_ERROR,
  GET_QF_CREATIVES_STATS_SUCCESS,
  MODIFY_AD,
  MODIFY_AD_ERROR,
  MODIFY_AD_SUCCESS,
  NEW_AD_ERROR,
  NEW_AD_SUCCESS
} from "./actionTypes"

// GET_ADS

/**
 * 
 * @param {Object} payload Object with queryParams, time_frame_key
 * @returns 
 */
export const getAds = payload => {
  return {
    type: GET_ADS,
    payload: payload,
  }
}

export const getAdsSuccess = (ad, time_frame_key) => {
  return {
    type: GET_ADS_SUCCESS,
    payload: ad,
    time_frame_key: time_frame_key
  }
}

export const getAdsError = error => {
  return {
    type: GET_ADS_ERROR,
    payload: error,
  }
}

/**
 * 
 * @param {Object} payload Object with queryParams, time_frame_key
 * @returns 
 */
export const getAdsStats = payload => {
  return {
    type: GET_ADS_STATS,
    payload: payload,
  }
}

export const getAdsStatsSuccess = (ad, time_frame_key) => {
  return {
    type: GET_ADS_STATS_SUCCESS,
    payload: ad,
    time_frame_key: time_frame_key
  }
}

export const getAdsStatsError = error => {
  return {
    type: GET_ADS_STATS_ERROR,
    payload: error,
  }
}

// GET_QF_CREATIVES_STATS

export const getQfCreativesStats = payload => {
  return {
    type: GET_QF_CREATIVES_STATS,
    payload: payload,
  }
}

export const getQfCreativesStatsSuccess = (data, time_frame_key) => {
  return {
    type: GET_QF_CREATIVES_STATS_SUCCESS,
    payload: data,
    time_frame_key: time_frame_key
  }
}

export const getQfCreativesStatsError = error => {
  return {
    type: GET_QF_CREATIVES_STATS_ERROR,
    payload: error,
  }
}

// GET_AD_BY_ID

export const getAdById = AdId => {
  return {
    type: GET_AD_BY_ID,
    payload: AdId,
  }
}

export const getAdByIdSuccess = Ad => {
  return {
    type: GET_AD_BY_ID_SUCCESS,
    payload: Ad,
  }
}

export const getAdByIdError = error => {
  return {
    type: GET_AD_BY_ID_ERROR,
    payload: error,
  }
}

// DUPLICATE_AD

export const duplicateAd = Ad =>{
  return {
    type: DUPLICATE_AD,
    payload: Ad,
  }
}

export const duplicateAdSuccess = Ad =>{
  return {
    type: DUPLICATE_AD_SUCCESS,
    payload: Ad,
  }
}

export const duplicateAdError = error =>{
  return {
    type: DUPLICATE_AD_ERROR,
    payload: error,
  }
}



// CREATE_NEW_AD

export const createNewAd = (ad, history) => {
  return {
    type: CREATE_NEW_AD,
    payload: { ad, history },
  }
}

export const createNewAdSuccess = ad => {
  return {
    type: NEW_AD_SUCCESS,
    payload: ad,
  }
}

export const createNewAdError = error => {
  return {
    type: NEW_AD_ERROR,
    payload: error,
  }
}

// MODIFY_AD

export const modifyAd = (ad, history) => {
  return {
    type: MODIFY_AD,
    payload: { ad, history },
  }
}


export const modifyAdSuccess = ad => {
  return {
    type: MODIFY_AD_SUCCESS,
    payload: ad,
  }
}

export const modifyAdError = error => {
  return {
    type: MODIFY_AD_ERROR,
    payload: error,
  }
}

// DELETE AD

export const deleteAd = ad => {
  return {
    type: DELETE_AD,
    payload: ad,
  }
}

export const deleteAdSuccess = ad => {
  return {
    type: DELETE_AD_SUCCESS,
    payload: ad,
  }
}

export const deleteAdError = error => {
  return {
    type: DELETE_AD_ERROR,
    payload: error,
  }
}



